import { Button, Checkbox, Modal, Radio, Form } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import WorkflowService from '../../../services/Workflow.service';
import IconApply from './iconApply';
import PropTypes from 'prop-types';

const ModalApply = ({
    open,
    handelClose,
    form,
    domainName = '',
    btnRef,
    domainId,
    workflowCode,
}) => {
    const { workflowId } = useParams();
    const applyWorkflowUnderDomain = Form.useWatch(
        'applyWorkflowUnderDomain',
        form
    );
    const workflowUnderDomain = Form.useWatch('workflowUnderDomain', form);
    const { t } = useTranslation();

    const [workflowList, setWorkflowList] = useState([]);
    const [indeterminate, setIndeterminate] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    useEffect(() => {
        if (workflowUnderDomain) {
            form.setFieldsValue({ workflowUnderDomain });
            setIndeterminate(
                !!workflowUnderDomain.length &&
                    workflowUnderDomain.length < workflowList.length
            );
            setCheckAll(workflowUnderDomain.length === workflowList.length);
        }
    }, [form, workflowList.length, workflowUnderDomain]);

    const onCheckAllChange = ({ target: { checked } }) => {
        form?.setFieldsValue({
            workflowUnderDomain: checked
                ? workflowList.map((value) => value.workflowId)
                : [workflowId],
        });
        setIndeterminate(false);
        setCheckAll(checked);
    };

    useEffect(() => {
        const getWorkflowListDropdown = async () => {
            const payload = {
                domainId,
                s: workflowCode,
                sd: 'ASC',
            };
            try {
                const { data } = await WorkflowService.getWorkflowListDropdown(
                    payload
                );
                if (data?.resultCode === 1) {
                    setWorkflowList(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getWorkflowListDropdown();
    }, [domainId, workflowCode]);

    return (
        <Modal
            width={407}
            className="_modal"
            footer={false}
            open={open}
            onCancel={() => {
                handelClose();
            }}
        >
            <div className="text-center px-4">
                <IconApply />
                <div className="my-4">
                    <div className="text-[22px] font-semibold">
                        {t('Apply to workflow')}
                    </div>
                    <div className="text-xs">
                        {t(
                            'Which workflows do you want to apply this setting to'
                        )}
                    </div>
                </div>
                <Form.Item
                    className="text-left"
                    name="applyWorkflowUnderDomain"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Radio.Group className="space-y-2">
                        <Radio
                            className={
                                !applyWorkflowUnderDomain
                                    ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-full`
                                    : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-full`
                            }
                            key={1}
                            value={false}
                            style={{ lineHeight: '32px' }}
                        >
                            {t('Apply this setting to this workflow only')}
                        </Radio>
                        <Radio
                            className={
                                applyWorkflowUnderDomain
                                    ? `border-[#7B67FB] border-solid border rounded-lg p-2 shadow-md w-full`
                                    : `border-[#DBDBDB] border-solid border rounded-lg p-2 w-full`
                            }
                            key={2}
                            value={true}
                            style={{ lineHeight: '32px' }}
                        >
                            {t(
                                'Apply this setting to other workflows under the domain'
                            )}
                            {domainName}
                        </Radio>
                    </Radio.Group>
                </Form.Item>
                <div className="text-left" hidden={!applyWorkflowUnderDomain}>
                    <div className="mb-4">
                        <div className="text-[22px] font-semibold">
                            {t('Apply to other workflows')}
                        </div>
                        <div className="text-xs">
                            {t('Select the workflow to be deployed under')}{' '}
                            {domainName}
                        </div>
                    </div>
                    <div className="bg-[#F4F6FC] h-56 overflow-y-auto p-4 mb-4 rounded-md">
                        <Checkbox
                            indeterminate={indeterminate}
                            onChange={onCheckAllChange}
                            checked={checkAll}
                        >
                            {t('Select all')}
                        </Checkbox>
                        <Form.Item name="workflowUnderDomain">
                            <Checkbox.Group className="pl-2">
                                {workflowList.map((workflow) => (
                                    <>
                                        <Checkbox
                                            disabled={
                                                workflow.workflowId ===
                                                workflowId
                                            }
                                            key={workflow.workflowId}
                                            value={workflow.workflowId}
                                        >
                                            {workflow.workflowName}
                                        </Checkbox>
                                        <br />
                                    </>
                                ))}
                            </Checkbox.Group>
                        </Form.Item>
                    </div>
                </div>
                <Form.Item>
                    <Button
                        ghost
                        type="primary"
                        size="large"
                        className="px-10 mr-2"
                        onClick={() => {
                            handelClose();
                        }}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button
                        onClick={() => btnRef?.current?.click()}
                        type="primary"
                        size="large"
                        className="px-10"
                    >
                        {t('Submit')}
                    </Button>
                </Form.Item>
            </div>
        </Modal>
    );
};

ModalApply.propTypes = {
    open: PropTypes.bool,
    handelClose: PropTypes.func,
    form: PropTypes.object,
    domainName: PropTypes.string,
    btnRef: PropTypes.object,
    domainId: PropTypes.string,
    workflowCode: PropTypes.string,
};

export default ModalApply;
